export enum ActivityLogType {
  ERROR = 'errors',
  AUDIT = 'audit',
  RULE = 'rules',
  ALL= 'all'
}
